module.exports = __webpack_public_path__ + "static/media/discord.436be008.svg";